import type { FC } from 'react'
import type { CurrentRefinementsProvided } from 'react-instantsearch-core'
import { connectCurrentRefinements } from 'react-instantsearch-dom'
import './ProductFilterV1FilterCounter.scss'

type ProductFilterV1FilterCounterProps = CurrentRefinementsProvided & {
  attribute: string
}

const ProductFilterV1FilterCounterInner: FC<
  ProductFilterV1FilterCounterProps
> = ({ attribute, items }) => {
  const currentFillter = items.find(item => item.attribute === attribute)

  if (!currentFillter) {
    return null
  }

  return (
    <span className="product-filter-v1__filter-counter">
      ({currentFillter.items ? currentFillter.items.length : 1})
    </span>
  )
}

export const ProductFilterV1FilterCounter = connectCurrentRefinements(
  ProductFilterV1FilterCounterInner
)
